// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import api from '../../axios';

const budgetPeriodAPI = {
  // Budget Periods
  list: (params = {}) =>
    api.get('/api/budget/budget-periods/', { params }),

  create: (data) =>
    api.post('/api/budget/budget-periods/', data),

  detail: (id) =>
    api.get(`/api/budget/budget-periods/${id}/`),

  update: (id, data) =>
    api.patch(`/api/budget/budget-periods/${id}/`, data),

  delete: (id) =>
    api.delete(`/api/budget/budget-periods/${id}/`),

  // Allocations (nested under budget periods)
  createAllocation: (periodId, data) =>
    api.post(`/api/budget/budget-periods/${periodId}/allocations/`, data),

  updateAllocation: (periodId, allocationId, data) =>
    api.patch(
      `/api/budget/budget-periods/${periodId}/allocations/${allocationId}/`,
      data,
    ),

  deleteAllocation: (periodId, allocationId) =>
    api.delete(
      `/api/budget/budget-periods/${periodId}/allocations/${allocationId}/`,
    ),

  // ZBB Status check
  getZBBStatus: (periodId) =>
    api.get(`/api/budget/budget-periods/${periodId}/zbb_status/`),
};

export default budgetPeriodAPI;
